import { SubmissionError } from '#helper/submission-error';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { FETCH_PROJECT_ALERTS, CLEAR_PROJECT_ALERTS } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

export const fetchProjectAlerts = (
  id,
  includeArchived = false,
  includeIds,
  additionalIds
) => dispatch => {
  const searchParams = new URLSearchParams();

  if (includeArchived) {
    searchParams.set('includeArchived', includeArchived);
  }

  if (includeIds) {
    searchParams.set('includeIds', includeIds);
  }

  if (additionalIds) {
    searchParams.set('additionalIds', additionalIds);
  }

  dispatch(fetchAdditions(`project/${id}/alert?${searchParams.toString()}`, FETCH_PROJECT_ALERTS, { id }));
};

export const putProjectAlerts = (id, alerts) => async dispatch => {
  try {
    const res = await fetch(webPortalApi.buildApiUrl(`project/${id}/alert`), {
      method: 'PUT',
      body: JSON.stringify(alerts),
      ...getRequestOptions()
    });
    const response = await res.json();
    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
      throw new SubmissionError({ ...response, status: res.status });
    }

    return { success: true };
  } catch (e) {
    return { success: false, status: e.errors.status };
  }
};

export const clearProjectAlerts = () => dispatch => dispatch({ type: CLEAR_PROJECT_ALERTS });
